/* file description */

import React from 'react';
import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import { valueReplace } from './service';
import { Tooltip } from 'antd';
import * as ICONS from '@ant-design/icons';
import { useResultEventConfig } from './useResultEventConfig';


interface ViewRenderPropsType {
  children: any;
  rowIndex: number | undefined;
  field: any;
  value: any;
  rowData: any[];
}
const tabStyle = {
  cursor: 'pointer',
  color: '#0064ce',
};


export function ViewRender(props: ViewRenderPropsType) {
  const { utils, events, emitEvent } = useMetaStore();
  const { values } = useValuesStore();
  const { field, children, rowIndex, rowData = {}, ...otherProps } = props;

  // const event = events?.current?.find((e) => (e.moduleName === field.moduleName && e.fieldName === field.name));

  const { resultEventConfig } = useResultEventConfig(field);
  let newChildren = children;
  if (React.isValidElement(children)) {
    newChildren = React.cloneElement(children as any, { ...otherProps });
  }

  if (!props.value || !resultEventConfig) {
    return <>{newChildren}</>;
  }

  const onLabelClick = () => {
    emitEvent && emitEvent({
      value: rowData?.[field.name] || '',
      eventsIds: [resultEventConfig?.code],
      rowIndex,
      touchConfig: 'click',
      params: {
        rowData,
      },
    });
  };
  return (
    <div style={tabStyle} onClick={onLabelClick}>
      <Tooltip title={resultEventConfig?.tooltipText || '点击查看'}>
        <span style={{ textDecoration: 'underline' }}>{newChildren}</span>
        <span>{React.createElement(ICONS[resultEventConfig?.openIcon || 'LinkOutlined'])} </span>
      </Tooltip>
    </div>
  );
}
